import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinimize = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "#697586",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-arrows-minimize",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M5 9l4 0l0 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 3l6 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 15l4 0l0 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 21l6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 9l-4 0l0 -4" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 9l6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 15l-4 0l0 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 15l6 6" })
	]
});
export default SvgMinimize;
